import { ActionIcon } from "@mantine/core";
import IconDownload from "@tabler/icons-react/dist/esm/icons/IconDownload.mjs";

const DownloadDocument = ({ url, filename }) => {
  function downloadHandler() {
    const anchor = document.createElement("a");
    anchor.href = url;
    anchor.download = filename;
    anchor.style.display = "none";

    document.body.appendChild(anchor);
    anchor.click();
    document.body.removeChild(anchor);
  }

  return (
    <ActionIcon onClick={downloadHandler} variant="subtle">
      <IconDownload size={16} />
    </ActionIcon>
  );
};

export default DownloadDocument;
